import { render, staticRenderFns } from "./ProductSize.vue?vue&type=template&id=e4d6ff22&scoped=true"
import script from "./ProductSize.vue?vue&type=script&lang=js"
export * from "./ProductSize.vue?vue&type=script&lang=js"
import style0 from "./ProductSize.vue?vue&type=style&index=0&id=e4d6ff22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d6ff22",
  null
  
)

export default component.exports